import { _ } from "$json/lib/gettext";
/* -*- coding: utf-8 -*- */
const strings = {
  "lang": "de",
  "Input required": "Eingabe erforderlich",
  "Date required":
    "Datumeingabe erforderlich; verwenden Sie das Format TT.MM.JJJJ",
  "Choice required": "Wahl erforderlich",
  "Doubleclick to go back to this question":
    "Doubleclick om zu dieser Frage rück zu kehren",
  "create a new case": "eine neue Casus erstellen",
  "new": "neu",
  "Delete": "Löschen",
  "case": "Casus",
  "cases": "Casus",
  "Last opened": "Letzte Mal benutzt",
  "created": "erstellt",
  "report": "Rapport",
  "Sun": "So",
  "Mon": "Mo",
  "Tue": "Di",
  "Wed": "Mi",
  "Thu": "Do",
  "Fri": "Fr",
  "Sat": "Sa",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "März",
  "Apr": "April",
  "May": "Mai",
  "June": "Juni",
  "July": "Juli",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Okt",
  "Nov": "Nov",
  "Dec": "Dez",
  "press enter to accept": "Eingabetaste akzeptiert",
  "filter cases by name": "suche Casus bei Name",
  "field--value": "die Zahl",
  "field--date": "dieser Datum",
  "field--field": "diese Angabe",
  "field--list": "diese Optionen",
  "quoted--value": "die Zahl „{quotable}“",
  "quoted--date": "der Datum „{quotable}“",
  "quoted--field": "die Angabe „{quotable}“",
  "quoted--list": "die Optionen in der Liste „{quotable}“",
  "Value has to lie between {minimum} and {maximum}":
    "{quotable--init} soll sich zwischen {minimum} und {maximum} befinden",
  "A date before {minimum} is not allowed":
    "{quotable--init} darf nicht eher sein wie {minimum}; verwenden Sie das Format TT.MM.JJJJ",
  "Negative number or zero expected":
    "{quotable--init} soll negativ oder Null sein",
  "Negative number expected": "{quotable--init} soll negativ sein",
  "Value has to lie below {maximum}":
    "{quotable--init} soll unter {maximum+1} liegen",
  "Positive number or zero expected":
    "{quotable--init} soll Null oder höher sein",
  "Positive number expected":
    "{quotable--init} ist nicht eine Positive Zahl. Gebe eine positive Zahl ein.",
  "Value has to lie above {minimum-1}":
    "{quotable--init} ist nicht höher als {minimum}. Gebe eine Zahl ein höher als {minumum}.",
  "A date after {maximum} is not allowed":
    "{quotable--init} darf nicht nach dem {maximum} liegen; verwenden Sie das Format TT.MM.JJJJ",
  "Date has to lie between {minimum} and {maximum}":
    "{quotable--init} soll sich zwischen {minimum} und {maximum} befinden; verwenden Sie das Format TT.MM.JJJJ",
  "Invalid date":
    "{quotable--init} ist kein gültiger Datum; verwenden Sie das Format TT.MM.JJJJ",
  "Text length exceeds the maximum of {maxlength} characters":
    "Maximum für {quotable}: {maxlength} Karakter",
  "Maximum allowed characters: {0}": "Maximum: {0} Karakter",
  "click for more...": "Zeige mir mehr...",
  " (click to open link)": " (Klicken Sie um dieser Seite zu öffnen)",
  "Are you sure? This will reset all values.":
    "Sind sie sicher? Dadurch weden alle Werte gelöscht.",
  "Yesterday": "Gestern",
  "No valid session": "Benutzer oder Passwort ungültig",
  "No interfaces to show":
    "Keine sichtbare Elemente (Fragen, Tekstfelder...) verfügbar",
  "Interface has failed (probably a failing SOAP or database connection)":
    "Schnittstelle ist ausgefallen (wahrscheinlich ein fehlerhafte SOAP- oder Datenbank-Verbindung)",
  "Choose...": "Wählen Sie...",
  "Choose or type...": "Wählen oder tippen Sie...",
  "cUMWrongUserNamePassword": "Benutzer oder Passwort ungültig",
  "cWebIllegalAccess": "Sie dürfen diese Casus nicht anfangen.",
  "cWebCaseIsRunning":
    "Kann diese Casus nicht öffnen, weil diese Casus schon auf eine andere Stelle geöffnet ist",
  "The model you are trying to open does not exist": "Modell existiert nicht",
  "You may now safely close this window":
    "Sie können jetzt dieses Fenster schließen",
  "user name": "Benutzer",
  "password": "Passwort",
  "Your models": "Ihre Modelle",
  "Your sessions": "Ihre Sessionen",
  "log in": "einloggen",
  "Choose the session file you saved earlier":
    "Wählen sie die Session-Datei, die Sie zuvor gespeichert haben",
  "Error loading session (wrong data)": "Fehler beim Laden (falsche Daten).",
  "Model is library, which cannot run stand alone":
    "Das Modell ist ein Bibliotheksmodell, das nicht eigenständig ausgeführt werden kann.",
  "Please login": "Bitte einloggen",
  "open": "öffnen",
  'You have no tickets left for model "{0}"':
    'Sie haben keine Tickets mehr für das Modell "{0}"',
  "__digitgroupingchar__": "'",
  "__radixpoint__": ",",
  "__digitgroupingrules__": [3],
  "Invalid number": "Ungültige Zahl",
  "attachments": "Anlagen",
  "your documents": "Ihre Dokumente",
  "saved sessions": "gespeicherte Sessionen",
  "We are currently updating. Please try again later.":
    "Wir sind derzeit zu aktualisieren. Bitte versuchen Sie es später noch einmal.",
  "case name": "Casusname",
  "dateplaceholder": "TT.MM.JJJJ",
  "Error: No response from server, server probably down":
    "Der Server reagiert nicht.",
  "Session has timed out. Please log in again.":
    "Die Session ist abgelaufen. Bitte melden Sie sich erneut an.",
  "first {0} results": "erste {0} Resultaten",
  "previous {0} results": "vorige {0} Resultaten",
  "next {0} results": "nächste {0} Resultaten",
  "last {0} results": "letzte {0} Resultaten",
  "add row": "Zeile hinzufügen",
  "insert row": "Zeile einfügen",
  "delete row": "diese Zeile löschen",
  "There are errors, please double check your answers.":
    "Es gibt Fehler, bitte kontrollieren sie ihre Antworten.",
  "cancel": "stornieren",
  "Something went wrong; see the server log for more information.":
    "Es ist etwas schief gelaufen; weitere Informationen finden Sie im Serverprotokoll.",
  "There does not seem to be an open session.":
    "Es scheint keine geöffnete Session zu geben"
};

_.set(strings);

export { strings };
